export const onboardCss = `
  :host {
    width: 100% !important;
    display: none;
  }
  .fixed {
    position: static !important;
  }
  .sidebar {
    display: none !important;
  }
  .content {
    width: 484px !important;
    padding: 0 22px !important;
  }
  .header{
    display: none !important;
  }
  .close-button{
    display: none !important;
  }
  .wallets-container {
    border: none !important;
  }
  .spacer {
    padding: 0px !important;
  }
  .container {
    height: 268px !important
  }
  .background {
    width: initial !important;
    height: initial !important;
  }
  .background {
    pointer-events: none !important;
  }
  .modal-position {
    pointer-events: auto !important;
    position: static !important;
  }

  section.fixed + div {
    display: none !important;
  }

  @media (max-width: 600px) {
    .mobile-header {
      display: none !important;
    }
    .wallet-button-container {
      padding: 0 30px !important;
    }
    .wallet-button-container-inner {
      width: auto !important;
      padding: 0px !important;
    }
    .wallet-button-container-inner > div {
      width: 90px !important;
      height: 90px !important;
    }
    .wallet-button-container-inner .name {
      font-size: 14px !important;
    }
    .wallets-container {
      display: grid !important;
      grid-template-columns: repeat(var(--onboard-wallet-columns, 2), 1fr) !important;
      padding: 1rem !important;
    }
    .fixed {
      margin-top: 20px !important;
    }
    .outer-container {
      padding: 0px !important;
    }
    .background {
      height: auto !important;
    }
    .container {
      height: auto !important;
      background: transparent !important;
    }
    .modal {
      background: transparent !important;
    }
    .content {
      width: auto !important;
    }
  }
`;
